import JobDetailRow from './jobDetailRow';
import * as React from 'react';
import cn from 'classnames';
import { Link } from 'gatsby';
import Img from 'gatsby-image';

const JobRow = ({
                  data,
                  even = false,
                  selectedAreas,
                  selectedIndustries,
                  selectedPeriod = { value: 0 },
                  selectedEmployerTypes,
                  selectedTypes
                }) => {

  const includes = (selected, value) => {
    return selected?.some(ele => ele.value === value);
  };

  return <div
    className={cn('w-full md:max-w-md lg:max-w-none flex flex-col space-y-4 lg:grid lg:grid-cols-7 lg:gap-x-2 xl:gap-x-8 rounded-lg p-2 items-center mx-auto ring', {
      'bg-gray-50 bg-opacity-50': !even,
      'ring-primary': data.prioritized,
      'ring-gray-100': !data.prioritized
    })}>
    <Img
      fixed={data.image.fixed}
      alt={data.image.title}
      className='!w-[120px] !h-[120px] rounded-xl mx-auto'
    />
    <div className='flex flex-col col-span-5 space-y-4 px-2'>
      <div className='flex flex-col space-y-2 lg:space-y-1'>
        <Link to={data.fields.slug} className='text-2xl italic'>{data.title}</Link>
        <p className='text-lg'>{data.employer}</p>
        <JobDetailRow data={data} dark spread />
      </div>
      <div className='flex flex-wrap lg:space-x-2 justify-center lg:justify-start items-center'>
        {includes(selectedIndustries, data.industry) &&
        <p className='border-2 border-black rounded-lg px-2 py-1 m-2'>{data.industry}</p>}
        {includes(selectedTypes, data.type) &&
        <p className='border-2 border-black rounded-lg px-2 py-1 m-2'>{data.type}</p>}
        {(data.minPeriod <= selectedPeriod?.value ?? 0) &&
        <p className='border-2 border-black rounded-lg px-2 py-1 m-2'>T-{data.minPeriod}</p>}
        {includes(selectedAreas, data.area) &&
        <p className='border-2 border-black rounded-lg px-2 py-1 m-2'>{data.area}</p>}
        {includes(selectedEmployerTypes, data.employerType) &&
        <p className='border-2 border-black rounded-lg px-2 py-1 m-2'>{data.employerType}</p>}
      </div>
    </div>
    <div className='flex flex-col w-full items-center justify-center text-center'>
      <Link to={data.fields.slug} className='text-lg btn-primary'>Läs mer</Link>
    </div>
  </div>;
};

export default JobRow;